import { useSelector } from 'react-redux';
import { selectUserStatsData } from '@client/user-stats';
import { UserStatsType } from 'b2b-common/core/user-stats';

export const useUserStatsData = (): UserStatsType => useSelector(selectUserStatsData);
